/**
 * Created by USER on 18/6/4.
 */
export const ADD_ADDRESS = 'ADD_ADDRESS'; // 控制顶部栏的变化

export function addAddress(data) {
  return {
    type: ADD_ADDRESS,
    data
  };
}
